"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLUMN_PRESET_ACTIVE_ID_SET = exports.COLUMN_PRESET_ACTIVE_SET = exports.COLUMN_PRESET_UPDATE = exports.COLUMN_PRESET_CREATE = exports.COLUMN_PRESETS_SET = exports.COLUMN_PRESETS_GET_OR_FETCH = exports.COLUMN_PRESETS_FETCH = exports.COLUMN_PRESET_REMOVE = exports.COLUMN_PRESET_ACTIVE_ID_GET = exports.COLUMN_PRESET_ACTIVE_GET = exports.COLUMN_PRESETS_GET = exports.COLUMN_PRESETS_LOADING_GET = exports.COLUMN_PRESETS_INITIAL_FETCH_DONE_SET = exports.COLUMN_PRESETS_LOADING_SET = exports.COLUMN_PRESETS_STATE_SET = void 0;
var apiCalls_1 = require("Modules/explorers/api/apiCalls");
var explorerColumnDefaultPresetsByType_1 = require("Modules/explorers/constants/explorerColumnDefaultPresetsByType");
var ExplorerColumnPresetType_1 = require("Modules/explorers/types/ExplorerColumnPresetType");
exports.COLUMN_PRESETS_STATE_SET = "column-presets/state/set";
exports.COLUMN_PRESETS_LOADING_SET = "column-presets/loading/set";
exports.COLUMN_PRESETS_INITIAL_FETCH_DONE_SET = "column-presets/initial-fetch/set";
exports.COLUMN_PRESETS_LOADING_GET = "column-presets/loading/get";
exports.COLUMN_PRESETS_GET = "column-presets/get";
exports.COLUMN_PRESET_ACTIVE_GET = "column-preset/active/get";
exports.COLUMN_PRESET_ACTIVE_ID_GET = "column-preset/active-id/get";
exports.COLUMN_PRESET_REMOVE = "column-preset/remove";
exports.COLUMN_PRESETS_FETCH = "column-presets/fetch";
exports.COLUMN_PRESETS_GET_OR_FETCH = "column-presets/get-or-fetch";
exports.COLUMN_PRESETS_SET = "column-presets/set";
exports.COLUMN_PRESET_CREATE = "column-preset/create";
exports.COLUMN_PRESET_UPDATE = "column-preset/update";
exports.COLUMN_PRESET_ACTIVE_SET = "column-preset/active/set";
exports.COLUMN_PRESET_ACTIVE_ID_SET = "column-preset/active-id/set";
var state = {
    initialFetchDone: (_a = {},
        _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = false,
        _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = false,
        _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = false,
        _a),
    loading: (_b = {},
        _b[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = false,
        _b[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = false,
        _b[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = false,
        _b),
    activePresetIds: (_c = {},
        _c[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users].id,
        _c[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups].id,
        _c[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = null,
        _c),
    activePresets: (_d = {},
        _d[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users],
        _d[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups],
        _d[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = null,
        _d),
    presets: (_e = {},
        _e[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = [
            explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users],
        ],
        _e[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = [
            explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups],
        ],
        _e[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = [],
        _e),
};
var getters = (_f = {},
    _f[exports.COLUMN_PRESETS_GET] = function (state) {
        return function (type) {
            return state.presets[type];
        };
    },
    _f[exports.COLUMN_PRESET_ACTIVE_GET] = function (state) {
        return function (type) {
            return state.activePresets[type];
        };
    },
    _f[exports.COLUMN_PRESET_ACTIVE_ID_GET] = function (state) {
        return function (type) {
            return state.activePresetIds[type];
        };
    },
    _f[exports.COLUMN_PRESETS_LOADING_GET] = function (state) {
        return function (type) {
            return state.loading[type];
        };
    },
    _f);
var actions = (_g = {},
    _g[exports.COLUMN_PRESETS_GET_OR_FETCH] = function (_a, type_1) { return __awaiter(void 0, [_a, type_1], void 0, function (_b, type) {
        var presets;
        var commit = _b.commit, state = _b.state, dispatch = _b.dispatch;
        return __generator(this, function (_c) {
            presets = state.presets[type];
            if (state.initialFetchDone[type])
                return [2 /*return*/, Promise.resolve(presets)];
            return [2 /*return*/, dispatch(exports.COLUMN_PRESETS_FETCH, type)];
        });
    }); },
    _g[exports.COLUMN_PRESETS_FETCH] = function (_a, type_1) { return __awaiter(void 0, [_a, type_1], void 0, function (_b, type) {
        var data, parsedPresets, presetsWithDefault, activePresetId, activePreset;
        var commit = _b.commit, state = _b.state;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    commit(exports.COLUMN_PRESETS_LOADING_SET, { type: type, value: true });
                    return [4 /*yield*/, (0, apiCalls_1.getExplorerPresetsByType)(type)];
                case 1:
                    data = (_c.sent()).data;
                    commit(exports.COLUMN_PRESETS_INITIAL_FETCH_DONE_SET, type);
                    parsedPresets = data.map(function (i) { return (__assign(__assign({}, i), { columns: i.columns })); });
                    presetsWithDefault = __spreadArray(__spreadArray([], parsedPresets, true), [
                        explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[type],
                    ], false);
                    commit(exports.COLUMN_PRESETS_SET, { type: type, presets: presetsWithDefault });
                    activePresetId = state.activePresetIds[type];
                    if (activePresetId !== null) {
                        activePreset = state.presets[type].find(function (i) { return i.id === activePresetId; });
                        if (activePreset)
                            commit(exports.COLUMN_PRESET_ACTIVE_SET, { type: type, preset: activePreset });
                    }
                    commit(exports.COLUMN_PRESETS_LOADING_SET, { type: type, value: false });
                    return [2 /*return*/, Promise.resolve(presetsWithDefault)];
            }
        });
    }); },
    _g[exports.COLUMN_PRESET_REMOVE] = function (_a, _b) { return __awaiter(void 0, [_a, _b], void 0, function (_c, _d) {
        var updatedState, e_1;
        var _e, _f, _g;
        var _h;
        var commit = _c.commit, state = _c.state;
        var type = _d.type, id = _d.id;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, apiCalls_1.explorerPresetRemove)(id)];
                case 1:
                    _j.sent();
                    updatedState = __assign(__assign({}, state), { activePresetIds: __assign(__assign({}, state.activePresetIds), (_e = {}, _e[type] = id === state.activePresetIds[type]
                            ? explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[type].id
                            : state.activePresetIds[type], _e)), activePresets: __assign(__assign({}, state.activePresets), (_f = {}, _f[type] = id === ((_h = state.activePresets[type]) === null || _h === void 0 ? void 0 : _h.id)
                            ? explorerColumnDefaultPresetsByType_1.explorerColumnDefaultPresetsByType[type]
                            : state.activePresets[type], _f)), presets: __assign(__assign({}, state.presets), (_g = {}, _g[type] = state.presets[type].filter(function (i) { return i.id !== id; }), _g)) });
                    commit(exports.COLUMN_PRESETS_STATE_SET, updatedState);
                    return [2 /*return*/, Promise.resolve()];
                case 2:
                    e_1 = _j.sent();
                    return [2 /*return*/, Promise.reject(e_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    _g[exports.COLUMN_PRESET_CREATE] = function (_a, payload_1) { return __awaiter(void 0, [_a, payload_1], void 0, function (_b, payload) {
        var newPreset, parsedPreset, updatedState, e_2;
        var _c;
        var commit = _b.commit, state = _b.state;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, apiCalls_1.explorerPresetCreate)(payload)];
                case 1:
                    newPreset = _d.sent();
                    parsedPreset = __assign(__assign({}, newPreset), { columns: newPreset.columns });
                    updatedState = __assign(__assign({}, state), { presets: __assign(__assign({}, state.presets), (_c = {}, _c[payload.type] = __spreadArray([parsedPreset], state.presets[payload.type], true), _c)) });
                    commit(exports.COLUMN_PRESETS_STATE_SET, updatedState);
                    return [2 /*return*/, Promise.resolve(parsedPreset)];
                case 2:
                    e_2 = _d.sent();
                    return [2 /*return*/, Promise.reject(e_2)];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    _g[exports.COLUMN_PRESET_UPDATE] = function (_a, payload_1) { return __awaiter(void 0, [_a, payload_1], void 0, function (_b, payload) {
        var updatedState, e_3;
        var _c, _d;
        var _e;
        var commit = _b.commit, state = _b.state;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, apiCalls_1.explorerPresetUpdate)(payload)];
                case 1:
                    _f.sent();
                    updatedState = __assign(__assign({}, state), { presets: __assign(__assign({}, state.presets), (_c = {}, _c[payload.type] = state.presets[payload.type].map(function (item) {
                            if (item.id === payload.id)
                                return payload;
                            return item;
                        }), _c)), activePresets: (_d = {},
                            _d[payload.type] = ((_e = state.activePresets[payload.type]) === null || _e === void 0 ? void 0 : _e.id) === payload.id
                                ? payload
                                : state.activePresets[payload.type],
                            _d) });
                    commit(exports.COLUMN_PRESETS_STATE_SET, updatedState);
                    return [2 /*return*/, Promise.resolve()];
                case 2:
                    e_3 = _f.sent();
                    return [2 /*return*/, Promise.reject(e_3)];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    _g);
var mutations = (_h = {},
    _h[exports.COLUMN_PRESETS_LOADING_SET] = function (state, _a) {
        var _b;
        var type = _a.type, value = _a.value;
        state.loading = __assign(__assign({}, state.loading), (_b = {}, _b[type] = value, _b));
    },
    _h[exports.COLUMN_PRESETS_STATE_SET] = function (state, updatedState) {
        state = Object.assign(state, updatedState);
    },
    _h[exports.COLUMN_PRESETS_SET] = function (state, payload) {
        var _a;
        state.presets = __assign(__assign({}, state.presets), (_a = {}, _a[payload.type] = payload.presets, _a));
    },
    _h[exports.COLUMN_PRESET_ACTIVE_SET] = function (state, payload) {
        var _a, _b;
        state.activePresets = __assign(__assign({}, state.activePresets), (_a = {}, _a[payload.type] = payload.preset, _a));
        state.activePresetIds = __assign(__assign({}, state.activePresetIds), (_b = {}, _b[payload.type] = payload.preset.id, _b));
    },
    _h[exports.COLUMN_PRESET_ACTIVE_ID_SET] = function (state, payload) {
        var _a, _b;
        var _c;
        var newActivePreset = (_c = state.presets[payload.type].find(function (i) {
            return i.id === payload.id;
        })) !== null && _c !== void 0 ? _c : null;
        state.activePresetIds = __assign(__assign({}, state.activePresetIds), (_a = {}, _a[payload.type] = payload.id, _a));
        state.activePresets = __assign(__assign({}, state.activePresets), (_b = {}, _b[payload.type] = newActivePreset, _b));
    },
    _h[exports.COLUMN_PRESETS_INITIAL_FETCH_DONE_SET] = function (state, type) {
        var _a;
        state = __assign(__assign({}, state), { initialFetchDone: __assign(__assign({}, state.initialFetchDone), (_a = {}, _a[type] = true, _a)) });
    },
    _h);
exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};
